export default __webpack_public_path__ + "static/why-tecalis_04-ecc7daaee990f5fc5f299047f30a354b.png";